export default __webpack_public_path__ + "static/support-2bb3a52c38a870ed603e0ed97963eb5a.jpg";